import { toast } from "react-toastify";
import Resizer from "react-image-file-resizer";

import {
  auntySvg,
  blueBorder,
  blueHorizontalStrip,
  blueStar,
  blueTitleBg,
  blueVerticleStrip,
  border1,
  brownFrame,
  darkBlueFrame,
  goldenBorder,
  goldenFrame,
  goldenHorizontalStrip,
  goldenTitleBg,
  goldenVerticleStrip,
  greenBorder,
  greenGirl,
  greenHorizontalStrip,
  greenstar,
  greenTitleBg,
  greenVerticlestrip,
  purpleFrame,
  redBorder,
  redFrame,
  redGirl,
  redHorizontalStrip,
  redStar,
  redTitleBg,
  redVerticleStrip,
  silverHorizontalstrip,
  silverStar,
  silverTitleBg,
  silverVerticleStrip,
  skyGreenFrame,
  smBlack1,
  smBlack2,
  smBlack3,
  smBlack4,
  smWhite1,
  smWhite2,
  smWhite3,
  smWhite4,
  yellowStar,
} from "../assets/images/imagePath";
import { Get } from "../Axios/AxiosFunctions";
import { BaseURL } from "../config/apiUrl";
import { signOutRequest } from "../redux/auth/authSlice";

export const calculateStarHeight = (starCount) => {
  if (starCount == 5) return "4.5px";
  if (starCount == 4) return "5.5px";
  if (starCount == 3) return "6.5px";
  if (starCount == 2) return "6.5px";
  if (starCount == 1) return "6.5px";
};

export const titleBgImages = [
  silverTitleBg,
  blueTitleBg,
  goldenTitleBg,
  greenTitleBg,
  redTitleBg,
];

export const frameImages = [
  goldenFrame,
  brownFrame,
  purpleFrame,
  redFrame,
  skyGreenFrame,
  darkBlueFrame,
];

export const borderImages = [
  border1,
  blueBorder,
  goldenBorder,
  greenBorder,
  redBorder,
];

export const horizontalStripImages = [
  silverHorizontalstrip,
  goldenHorizontalStrip,
  blueHorizontalStrip,
  greenHorizontalStrip,
  redHorizontalStrip,
];

export const verticalStripImages = [
  silverVerticleStrip,
  goldenVerticleStrip,
  blueVerticleStrip,
  greenVerticlestrip,
  redVerticleStrip,
];

export const starImages = [
  silverStar,
  yellowStar,
  blueStar,
  greenstar,
  redStar,
];

export const smIcons = [
  smBlack1,
  smBlack2,
  smBlack3,
  smBlack4,
  smWhite1,
  smWhite2,
  smWhite3,
  smWhite4,
];

export const mainBgImages = [auntySvg, greenGirl, redGirl];

export const _description = `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
optio, eaque rerum!`;

export const rangeSliderStyles = {
  height: "40px",
  padding: 0,
  "accent-color": "var(--primary-color)",
};

export const calculateCardGradient = (color1, color2, sp1, sp2) => {
  if (parseInt(sp1) > parseInt(sp2))
    return `linear-gradient(360deg, ${color2} ${sp2}%, ${color1} ${sp1}%)`;
  else if (parseInt(sp1) < parseInt(sp2))
    return `linear-gradient(360deg, ${color1} ${sp1}%, ${color2} ${sp2}%)`;
  else return `linear-gradient(360deg, ${color2} ${sp2}%, ${color1} ${sp1}%)`;
};

export const calculateTitleGradient = (color1, color2, sp1, sp2, isFlat) => {
  if (isFlat)
    return `radial-gradient(circle, ${color1} ${sp1}%, ${color1} ${sp1}%)`;

  if (parseInt(sp1) > parseInt(sp2))
    return `radial-gradient(circle, ${color2} ${sp2}%, ${color1} ${sp1}%)`;
  else if (parseInt(sp1) < parseInt(sp2))
    return `radial-gradient(circle, ${color1} ${sp1}%, ${color2} ${sp2}%)`;
  else return `radial-gradient(circle, ${color2} ${sp2}%, ${color1} ${sp1}%)`;
};

export const boldAndItalicStyles = (fontStyle, fontWeight) => {
  return {
    fontStyle,
    fontWeight,
  };
};

export const calculateTotalAmount = (cart, singleCardPrice) => {
  const totalAmount = cart.reduce((val, acc) => {
    const isCollection = typeof acc?.cards === "object";
    if (!isCollection) val += parseFloat(singleCardPrice) * acc?.quantity;
    if (isCollection)
      val += parseFloat(singleCardPrice) * acc?.cards?.length * acc?.quantity;

    return val;
  }, 0);

  return totalAmount;
};

export function dataURLtoFile(dataurl, filename = `${Math.random()}.jpeg`) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const cardDimentionsAtScaleX = (x) => ({
  width: `${198 * x}px`,
  height: `${270 * x}px`,
});

export const getMe = async (dispatch, token, navigate) => {
  const url = BaseURL("users/me");
  const response = await Get(url, token);
  if (response !== undefined) {
    if (!response?.data?.data?.user?.isActive) {
      toast.error(
        "Your account has been blocked by admin. Kindly contact support for more information."
      );
      dispatch(signOutRequest());
      navigate("/");
    }
  }
};

export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      825,
      1125,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      825,
      1125
    );
  });
